<template>
    <div class="d-flex flex-row flex-nowrap">
        <DateComp
            v-if="lastActivity?.ClockTime"
            :value="lastActivity?.ClockTime"
            :format="isToday(lastActivity?.ClockTime ?? new Date()) ? 'TIME' : 'DATETIME'"
        ></DateComp>
        <span
            class="flex-fill text-end fw-semibold"
            v-if="lastActivityContestant != null && lastActivityContestant.Bib != null"
        >
            {{ lastActivityContestant?.Bib }}</span
        >
    </div>
</template>
<script lang="ts" setup>
/**
 * This will display the last activity for the station. It will listen to changes from the time store
 */
import { DateComp } from '@/components';
import { useLoaders, useTaskLoader } from '@/composeables';
import { ContestantBase, type ContestantTime, type Station } from '@/objects/generated';
import { useContestantStore, useContestantTimesSubscription, useContestantTimeStore } from '@/stores';
import { isToday } from '@/utilities/dateutils';
import { ref } from 'vue';

const props = defineProps<{
    /**
     * The value to display
     */
    value: number;

    row: Station;
}>();

const lastActivity = ref<ContestantTime | null>(null);
const lastActivityContestant = ref<ContestantBase | null>(null);

/**
 * We need to use the contestant time store
 */
const contestantTimeStore = useContestantTimeStore();

/**
 * We need to access the contestant store
 */
const contestantStore = useContestantStore();

/**
 * We need to load the activetimes so we can display the last activity
 */
const { AddLoader } = useTaskLoader();
useLoaders(AddLoader, ['ACTIVETIMES', 'CONTESTANTS']);

useContestantTimesSubscription(
    (times) => {
        // We assume that the list is ordered by timestamp ascending
        // We iterate from the bottom to the first one with stationId = props.value
        if (times.length > 0) {
            for (let i = times.length - 1; i >= 0; i--) {
                const time = times[i];
                if (time.StationID === props.value) {
                    lastActivity.value = time;
                    lastActivityContestant.value =
                        time.ContestantID === null ? null : (contestantStore.GetContestants([time.ContestantID!]).at(0) ?? null);
                    break;
                }
            }
        }
    },
    {
        triggerForExistingTimes: true, // We want all the existing times to be sent to the matrixViewMain
    },
);
</script>
